import React from 'react';
import Sticky from 'react-stickynode';
import { createGlobalStyle } from 'styled-components'
import SiteNavigation from './components/SiteNavigation';
import SiteFooter from './components/SiteFooter';
import { Router } from '@reach/router';

import { Home } from './pages/Home';
import { Portfolios } from './pages/Portfolios';
import { About } from './pages/About';

// Redirect application 
if (window.location.hostname === 'toyotaipsolutions.com'){
  window.location.href = 'https://www.toyotaipsolutions.com/';
}

(function() {
  if (document.querySelector('#not-supported') || !/Trident\/|MSIE/.test(window.navigator.userAgent)) {
      return;
  }
  var myDiv = document.createElement("div");
  myDiv.innerHTML = '<div id="not-supported" style=" background: rgba(0, 0, 0, 0.5); position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 9999; "> <div style=" width: calc(100% - 40px); max-width: 600px; background: #fff; color: #000; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); box-sizing: border-box; padding: 25px; text-align: center; font-size: 16px; line-height: 1.2; height: 300px; display: flex; align-items: center; justify-content: center; " > <div> <div style="font-family: Arial; font-weight: bold; margin-bottom: 15px;"> ToyotaIPSolutions.comではInternet Explorerのサポートを終了しました。<br/>下記推奨ブラウザのご利用をお願い致します。</div><div style="font-family: Arial; font-weight: bold; margin-bottom: 5px;"> Internet Explorer is no longer supported on ToyotaIPSolutions.com. </div><div style="font-family: Arial; font-weight: normal"> Please access this site using a different browser.<br/>We recommend: </div><div style="display: flex; justify-content: space-around; padding-top: 25px" > <a href="https://www.google.com/chrome/" ><img src="https://cdnjs.cloudflare.com/ajax/libs/browser-logos/69.0.4/chrome/chrome_64x64.png" alt="Chrome"/></a> <a href="https://www.mozilla.org/en-US/firefox/" ><img src="https://cdnjs.cloudflare.com/ajax/libs/browser-logos/69.0.4/firefox/firefox_64x64.png" alt="Firefox"/></a ><a href="https://www.microsoft.com/en-us/edge" ><img src="https://cdnjs.cloudflare.com/ajax/libs/browser-logos/69.0.4/edge/edge_64x64.png" alt="Edge"/></a > </div></div></div></div>';
  document.body.appendChild(myDiv);
  })();

    

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
  }
  [class*='baseStyles__BaseModalBackground'] {
    height: 100%;
    overflow-y: scroll;
  }
`

function App() {
  return (
    <div className="App">
      <GlobalStyle/>
      <Sticky enabled={true} innerZ={10}>
        <SiteNavigation />  
      </Sticky>
      <Router>
        <Home path='/' />
        <Portfolios path='/portfolios' />
        <Portfolios path='/portfolios/:category' />
        <About path='/about' />
        <About path='/about/:section' />
      </Router>
      <SiteFooter />
    </div>
  );
}

export default App;
